import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Col, Row, Typography } from "antd";

import Plot from "react-plotly.js";

import { fetchSurveyAnalyticsApi } from "utils/apiService";

import totalResponse from "../../media/survey-total-response-icon.svg";
import avgRecScore from "../../media/survey-avg-rec-score-icon.svg";
import surveyQuestions from "../../media/survey-question-number-icon.svg";
import responseRate from "../../media/survey-response-rate-icon.svg";
import Loader from "components/Loader/Loader";

const Text = Typography;

const BarPlot = ({ value_list, option_list }) => {
  return (
    <Plot
      data={[
        {
          x: option_list,
          y: value_list,

          type: "bar",
        },
      ]}
      layout={{ xaxis: { range: [0, 10], dtick: 1 } }}
      config={{ displayModeBar: false }}
    />
  );
};

const PiePlot = ({ value_list, option_list }) => {
  return (
    <Plot
      data={[
        {
          values: value_list,
          labels: option_list,
          type: "pie",
        },
      ]}
      config={{ displayModeBar: false }}
      // layout={{ width: 600, height:350 }}
    />
  );
};

const SurveyStat = ({ text, data, imgSrc }) => {
  return (
    <>
      <Row
        type="flex"
        gutter={[12, 12]}
        align="middle"
        style={{
          background: "#FFFFFF",
          border: "1px solid #F2F2F2",
          boxSizing: "border-box",
          padding: "10px 20px",
          borderRadius: "8px",
        }}
      >
        <Col>
          <img
            src={imgSrc}
            style={{
              width: "40px",
              height: "40px",
            }}
            alt={"Illustration"}
          />
        </Col>
        <Col>
          <Text
            style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}
          >
            {data !== undefined && data !== null
              ? data + (text === "Average Rec. Score" && "/10")
              : "-"}
          </Text>
          <Text
            style={{
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "22px",
              color: "#747474",
            }}
          >
            {text}
          </Text>
        </Col>
      </Row>
    </>
  );
};

const SurveyStats = (props) => {
  const surveyAnalytics = [
    {
      imgSrc: totalResponse,
      text: "Total Responses",
      data: props.loading ? "..." : props.data?.response_count,
    },
    {
      imgSrc: avgRecScore,
      text: "Average Rec. Score",
      data: props.loading
        ? "..."
        : props.data?.avg_recommendation_score?.toFixed(2),
    },
    {
      imgSrc: surveyQuestions,
      text: "Survey Questions",
      data: props.loading ? "..." : props.data?.question_count,
    },
    // {
    // 	imgSrc: responseRate,
    // 	text: "Response Rate",
    // 	data: props.loading ? "..." : props.data?.response_rate,
    // },
  ];

  return (
    <>
      <Row
        type="flex"
        gutter={[32, 12]}
        style={{
          margin: "22px -10px",
        }}
      >
        {surveyAnalytics.map((surveyStat, index) => (
          <Col key={index} style={{ flexGrow: 1, flexBasis: 0 }}>
            <SurveyStat {...surveyStat} />
          </Col>
        ))}
      </Row>
    </>
  );
};

const SurveyPlots = ({ question_summary }) => {
  return question_summary?.length
    ? question_summary?.map(
        (question) =>
          question.type !== "paragraph" && (
            <Row
              style={{
                padding: 20,
                backgroundColor: "#FFFFFF",
                border: "1px solid #F2F2F2",
                boxSizing: "border-box",
                borderRadius: "8px",
                marginBottom: "20px",
              }}
            >
              <Text
                style={{
                  // fontFamily: "Gotham",
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "17px",
                  lineHeight: "24px",
                  color: "#181818",
                  marginBottom: "8px",
                }}
              >
                {question.question}
              </Text>
              {question.type === "nps" ? (
                <BarPlot
                  value_list={question.value_list}
                  option_list={question.option_list}
                />
              ) : question.type === "mcq" ? (
                <PiePlot
                  value_list={question.value_list}
                  option_list={question.option_list}
                />
              ) : null}
            </Row>
          )
      )
    : null;
};

const SurveyAnalytics = (props) => {
  const [loading, setLoading] = useState(true);
  const [surveyAnalyticsData, setSurveyAnalyticsData] = useState({});

  const { formID } = useParams();

  useEffect(() => {
    fetchSurveyAnalyticsApi({
      requestData: {
        uuid: formID,
      },
      resCallback: () => {
        loading && setLoading(false);
      },
      res200Callback: (res) => {
        setSurveyAnalyticsData({ ...res.data });
      },
    });
  }, []);

  return loading ? (
    <Row
      type="flex"
      align="middle"
      justify="center"
      style={{ marginTop: "200px" }}
    >
      <Loader />
    </Row>
  ) : (
    <>
      <SurveyStats
        loading={loading}
        data={{
          response_count: surveyAnalyticsData.response_count,
          avg_recommendation_score:
            surveyAnalyticsData.avg_recommendation_score,
          question_count: surveyAnalyticsData.question_count,
          response_rate: surveyAnalyticsData.response_rate,
        }}
      />
      <SurveyPlots
        question_summary={surveyAnalyticsData.question_summary}
        loading={loading}
      />
    </>
  );
};

export default SurveyAnalytics;
